const DEFAULT_CURRENCY = 'EUR';

const LANGUAGE_TO_LOCALE: Record<string, string> = {
  bg: 'bg-BG',
  en: 'en-US',
  nl: 'nl-NL',
};

const toLocale = (language: string): string => {
  const shortLanguage = (language || 'en').split('-')[0].toLowerCase();
  return LANGUAGE_TO_LOCALE[shortLanguage] || 'en-US';
};

export const formatCurrency = (
  amount: number,
  language: string,
  currency: string = DEFAULT_CURRENCY,
  options?: Intl.NumberFormatOptions
): string => {
  const locale = toLocale(language);
  const hasFraction = !Number.isInteger(amount);

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency || DEFAULT_CURRENCY,
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: hasFraction ? 2 : 0,
    ...options,
  }).format(amount);
};

export const getCurrencySymbol = (language: string, currency: string = DEFAULT_CURRENCY): string => {
  const locale = toLocale(language);
  const parts = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency || DEFAULT_CURRENCY,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).formatToParts(0);

  return parts.find((part) => part.type === 'currency')?.value || '€';
};
